module.exports = __webpack_public_path__ + "static/img/tit2.ca593375.png";